module.exports = __webpack_public_path__ + "static/media/FooterLogo.82302e2e.jpg";